import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { Holding } from '../types';
import type { PaginatedResponse } from '@shared/types';

export interface UseHoldingsParams {
  search?: string;
  type?: string;
  status?: string;
  coverage?: string;
  page?: number;
  size?: number;
}

export function useHoldings(params: UseHoldingsParams = {}) {
  const { search, type, status, coverage, page = 0, size = 25 } = params;

  const queryParams: Record<string, string> = {
    page: String(page + 1),
    size: String(size),
  };
  if (search) queryParams.search = search;
  if (type) queryParams.type = type;
  if (status) queryParams.status = status;
  if (coverage) queryParams.coverage = coverage;

  return useQuery({
    queryKey: queryKeys.holdings({ search, type, status, coverage, page, size }),
    queryFn: () => apiClient.get<PaginatedResponse<Holding>>('/holdings', queryParams),
    placeholderData: keepPreviousData,
  });
}
